var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"mdi mdi-24px",class:['mdi-' + _vm.icon, 'has-text-' + _vm.color]})])
}
var staticRenderFns = []

export { render, staticRenderFns }